<div *ngIf="!!tabsModel" class="tabs-wrapper">
  <ng-container *ngFor="let tab of tabsModel.tabs; trackBy: trackById">
    <flo-link
      data-test="flo-tab"
      [link]="tab"
      (linkClick)="handleTabClick($event)"
      tagName="Tab"
    >
    </flo-link>
  </ng-container>
</div>
